import { useState } from "react";
import Reveal from "@/components/base/Reveal";
import { playModes } from "@/mocks/siteData";

export default function PlayModes() {
  const [active, setActive] = useState(playModes[0].id);
  const current = playModes.find((m) => m.id === active) ?? playModes[0];

  return (
    <section id="modes" className="bg-background-50 py-16 md:py-24 scroll-mt-20">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <Reveal>
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 text-xs font-medium tracking-widest text-primary-600 uppercase">
              <span className="w-6 h-px bg-primary-400"></span>
              播放方式
            </span>
            <h2 className="mt-4 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
              四种播放方式，切换查看各自的重点
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              点选下面的方向标签，右侧会同步展示该方式的说明、特点与适用人群。内容属于同一页面，切换不会跳转离开。
            </p>
          </div>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-10">
          <Reveal className="lg:col-span-4">
            <div
              role="tablist"
              aria-label="播放方式选择"
              className="flex lg:flex-col gap-2 overflow-x-auto lg:overflow-visible pb-2 lg:pb-0"
            >
              {playModes.map((mode) => {
                const isActive = mode.id === active;
                return (
                  <button
                    key={mode.id}
                    role="tab"
                    aria-selected={isActive}
                    onClick={() => setActive(mode.id)}
                    className={`flex items-center gap-3 px-4 py-3.5 rounded-lg border text-left transition-colors cursor-pointer whitespace-nowrap lg:whitespace-normal shrink-0 ${
                      isActive
                        ? "bg-primary-500 border-primary-500 text-background-50"
                        : "bg-background-100 border-background-200 text-foreground-700 hover:border-secondary-300 hover:bg-background-200/70"
                    }`}
                  >
                    <span
                      className={`w-9 h-9 flex items-center justify-center rounded-md shrink-0 ${
                        isActive ? "bg-background-50/15 text-background-50" : "bg-background-50 text-primary-600"
                      }`}
                    >
                      <i className={`${mode.icon} text-xl`} aria-hidden="true"></i>
                    </span>
                    <span className="text-sm md:text-base font-medium">{mode.label}</span>
                    <i
                      className={`hidden lg:block ml-auto transition-transform ${
                        isActive ? "ri-arrow-right-line text-background-50" : "ri-arrow-right-line text-foreground-300"
                      }`}
                      aria-hidden="true"
                    ></i>
                  </button>
                );
              })}
            </div>
          </Reveal>

          <div className="lg:col-span-8">
            <div className="bg-background-100 rounded-lg border border-background-200 p-6 md:p-8">
              <div className="flex items-start gap-3">
                <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-accent-100 text-accent-700 shrink-0">
                  <i className={`${current.icon} text-2xl`} aria-hidden="true"></i>
                </span>
                <div>
                  <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">{current.headline}</h3>
                  <span className="inline-block mt-1 text-xs text-secondary-600 tracking-wide">{current.label}方向</span>
                </div>
              </div>

              <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed">{current.desc}</p>

              <div className="mt-6 grid grid-cols-1 sm:grid-cols-3 gap-4">
                {current.features.map((f) => (
                  <div key={f.title} className="bg-background-50 rounded-lg border border-background-200 p-4">
                    <h4 className="text-sm font-semibold text-foreground-900 flex items-center gap-1.5">
                      <i className="ri-checkbox-blank-circle-fill text-[6px] text-primary-500" aria-hidden="true"></i>
                      {f.title}
                    </h4>
                    <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed">{f.text}</p>
                  </div>
                ))}
              </div>

              <div className="mt-6 flex items-start gap-2.5 pt-5 border-t border-background-200">
                <i className="ri-user-heart-line text-lg text-primary-600 mt-0.5 shrink-0" aria-hidden="true"></i>
                <p className="text-sm text-foreground-700 leading-relaxed">{current.fit}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}